import { render, staticRenderFns } from "./clothesDetailView.vue?vue&type=template&id=399b8fdc&scoped=true"
import script from "./clothesDetailView.vue?vue&type=script&lang=js"
export * from "./clothesDetailView.vue?vue&type=script&lang=js"
import style0 from "./clothesDetailView.vue?vue&type=style&index=0&id=399b8fdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399b8fdc",
  null
  
)

export default component.exports